import { ReducerCreators } from '@reduxjs/toolkit';
import { AudiencesState } from '../types';
import { GetPasscodeListMemberCount } from '@/connection/audiences/passcode-lists';

export const fetchPasscodeListMemberCount = (create: ReducerCreators<AudiencesState>) =>
  create.asyncThunk(
    async ({ passcodeListId, search }: { passcodeListId: number; search?: string }) => {
      const passcodeListMembers = await GetPasscodeListMemberCount(passcodeListId, search);
      return passcodeListMembers;
    },
    {
      fulfilled: (state, action) => {
        if (action.payload) {
          state.passcodeListMemberCount = action.payload[0].member_count;
        }
      },
    }
  );
